import { render, staticRenderFns } from "./proVillage.vue?vue&type=template&id=6129cb4a&scoped=true&"
import script from "./proVillage.vue?vue&type=script&lang=js&"
export * from "./proVillage.vue?vue&type=script&lang=js&"
import style0 from "./proVillage.vue?vue&type=style&index=0&id=6129cb4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129cb4a",
  null
  
)

export default component.exports